<template>
    <div>
        <el-pagination
                v-if="exist"
                style="clear:both;margin:20px 0"
                background
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :page-size=pageLimit
                :total=size
                class="pagination">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        data(){
            return{
                currentPage:1,
                exist:true
            }
        },
        methods:{
            handleCurrentChange(val) {
                //this.currentPage = val;
                this.$emit("changeCurrent",val)
            },
        },
        props:['size','pageLimit']
    }
</script>

<style scoped>

</style>
